module.exports = __webpack_public_path__ + "img/logo.c517e1b6.png";